export default __webpack_public_path__ + "static/media/mysql_logo.2f21a570.svg";